import { userKey } from 'data/constants'
import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { toast } from 'react-toastify'

const date = new Date()
const currentDate = `${date.getFullYear().toString()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
    .getDate()
    .toString()
    .padStart(2, '0')}`
const initialState = {
    startDate: currentDate,
    endDate: currentDate,
    ci: '',
}
const Seeker = ({ searchTeacherReports, reports = false }) => {
    const [seekerParams, setSeekerParams] = useState(initialState)
    const [loading, setLoading] = useState(false)

    const handleOnChange = (e) => {
        setSeekerParams({ ...seekerParams, [e.target.name]: e.target.value })
    }
    const handleClean = () => {
        setSeekerParams(initialState)
    }
    const handleSearch = () => {
        const smsError = isValid()
        if (smsError === true) {
            searchTeacherReports(seekerParams)
        } else {
            toast.error(smsError)
        }
    }
    const handleGenerate = async (detallado = false) => {
        try {
            setLoading(true)
            const token = JSON.parse(localStorage.getItem(userKey)).access_token
            const url = 'reporte/asistencia-pdf'
            const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                method: 'POST',
                body: JSON.stringify({ ...seekerParams, detallado }),
            })

            if (response.ok) {
                const blob = await response.blob()
                // Crear una URL local para el Blob
                const blobUrl = URL.createObjectURL(blob)
    
                // Abrir una nueva pestaña con el PDF
                window.open(blobUrl, '_blank')
            } else {
                toast.error('Ocurrió un error al obtener el reporte')
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }
    const generateAsistenciaCsv = async () => {
        try {
            setLoading(true)
            const token = JSON.parse(localStorage.getItem(userKey)).access_token
            const requestUrl = 'reporte/asistencia-csv'
            const response = await fetch(`${process.env.REACT_APP_API_URL}${requestUrl}`, {
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                method: 'POST',
                body: JSON.stringify(seekerParams),
            })

            if (response.ok) {
                const blob = await response.blob()
                // Crear una URL local para el Blob
                const url = URL.createObjectURL(blob)
    
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'asistencia.csv')
    
                // Simular clic en el enlace
                document.body.appendChild(link)
                link.click()
    
                // Limpiar el DOM
                link.parentNode.removeChild(link)
            } else {
                toast.error('Ocurrió un error al obtener el reporte')
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const isValid = () => {
        const { startDate, endDate } = seekerParams
        if (startDate && endDate) {
            if (startDate > endDate) {
                return 'Fechas incorrectas'
            }
        } else {
            return 'Debe ingresar las fechas'
        }
        // if(ci === ''){
        //   return 'Ingrese un carnet'
        // }
        return true
    }

    return (
        <div>
            <div className='seeker'>
                <div className='seeker__inputs align-items-end mb-3'>
                    <div className='seeker__input'>
                        <label className='form-label'>Fecha Inicio</label>
                        <Form.Control
                            type='date'
                            name='startDate'
                            value={seekerParams.startDate}
                            onChange={handleOnChange}
                        />
                    </div>
                    <div className='seeker__input'>
                        <label className='form-label'>Fecha Fin</label>
                        <Form.Control
                            type='date'
                            name='endDate'
                            value={seekerParams.endDate}
                            onChange={handleOnChange}
                        />
                    </div>
                    <div className='seeker__input'>
                        <label className='form-label'>Carnet Docente</label>
                        <Form.Control name='ci' value={seekerParams.ci} onChange={handleOnChange} />
                    </div>
                    <div>
                        <Button variant='blue' onClick={handleSearch} className='me-2'>
                            Buscar
                        </Button>
                        <Button variant='danger' onClick={handleClean}>
                            Limpiar Búsqueda
                        </Button>
                    </div>
                </div>

                {reports && (
                    <div>
                        <div className='mb-2'>
                            <span className='fw-bold me-2'>Generar PDF:</span>
                            <Button variant='blue' onClick={() => handleGenerate()} disabled={loading} className='me-2'>
                                {/* {loading && <Spinner size='sm' className='me-2'/>} */}
                                Reporte General
                            </Button>
                            <Button variant='blue' onClick={() => handleGenerate(true)} disabled={loading}>
                                {/* {loading && <Spinner size='sm' className='me-2'/>} */}
                                Reporte Detallado
                            </Button>
                        </div>
                        <div>
                            <span className='fw-bold me-2'>Generar CSV:</span>
                            <Button variant='blue' onClick={generateAsistenciaCsv} disabled={loading} className='me-2'>
                                {/* {loading && <Spinner size='sm' className='me-2'/>} */}
                                Reporte Asistencia
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Seeker
